import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';
import ReactLoading from 'react-loading';
import './style.scss';

const Button = ({ title, children, className, onClick, isDisabled, isLoading }) => (
  <button
    className={cn(className, isDisabled ? 'btn-disabled' : '')}
    onClick={onClick}
    disabled={isDisabled || isLoading}
    type="button"
  >
    {isLoading ? <div className="loadingWrapper"><ReactLoading width={24} height={24} /></div> : (title || children)}
  </button>
);

Button.propTypes = {
  title: PropTypes.string,
  className: PropTypes.string,
  onClick: PropTypes.func,
  isDisabled: PropTypes.bool,
  isLoading: PropTypes.bool,
  children: PropTypes.node,
};

Button.defaultProps = {
  title: '',
  className: '',
  onClick: () => {},
  isDisabled: false,
  isLoading: false,
  children: '',
};

export default Button;
